import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { GbAlteGrundbuchmeldungService } from './api/gbAlteGrundbuchmeldung.service';
import { GbdokulinkService } from './api/gbdokulink.service';
import { GbegvtauftraganmeldungService } from './api/gbegvtauftraganmeldung.service';
import { GbeigentumService } from './api/gbeigentum.service';
import { GbgemeindeService } from './api/gbgemeinde.service';
import { GbgrundbuchamtService } from './api/gbgrundbuchamt.service';
import { GbgrundbuchgeschaeftService } from './api/gbgrundbuchgeschaeft.service';
import { GbgrundbuchmeldungService } from './api/gbgrundbuchmeldung.service';
import { GbgrundstueckService } from './api/gbgrundstueck.service';
import { GbgrundstueckbemerkungService } from './api/gbgrundstueckbemerkung.service';
import { GbkuhrechtService } from './api/gbkuhrecht.service';
import { GbpersonService } from './api/gbperson.service';
import { GbpfandrechtService } from './api/gbpfandrecht.service';
import { GbprintService } from './api/gbprint.service';
import { GbpublikationService } from './api/gbpublikation.service';
import { GbrechtService } from './api/gbrecht.service';
import { GbsonderrechtService } from './api/gbsonderrecht.service';
import { GbstandardrechtService } from './api/gbstandardrecht.service';
import { GbtimepointService } from './api/gbtimepoint.service';
import { GbvertragService } from './api/gbvertrag.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
